module.exports = __webpack_public_path__ + "img/c07_unitwardog_Normal_ua.39358ca4.webp";